<template>
  
<div id="vy_body">
  <div id="vy_grid">
    <div id="vy_left_nav" class="p-4">
      <!--左サイドバー-->
      <ShakyoLeftbar v-on:call="call"/>
    </div>
    <div id="vy_main">
      <main>
  <div>
    <h2 class="kojin-title"><slot>{{ title }}</slot></h2>
  </div>
  
  <div id="manual_area">

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />インポート画面のマニュアル</span>
    <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

    </div>
    <br clear="all">
    <template v-if="inport_disp"> 
  <div align=center >
    
    ※ 研修No.、集会No.、プログラムNo.を入力した行を読み取ります。必要のない行にはNo.を入れないようにしてください。<br>
    また、申込開始日になるとご利用いただけません。
    <table>
      <tr>
        
        <td><h3 style="margin:0">年度を指定</h3></td>
        <td style="text-align: left;">
          <select v-model="disp_nendo">
            <option v-bind:value="(nendo-1)">{{ (nendo-1) }}</option>
            <option v-bind:value="nendo" >{{ nendo }}</option>
          </select>年度
        </td>
      </tr>
    
      <tr>
        <td><h3>事前研修プログラムCSVファイル</h3></td>
        <td><input type='file' id="jizen_file" @change="jizenChange" accept=".csv"/></td>
      </tr>
      <tr>
        <td colspan=2 style="text-align: center;">
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-if="jizen_complete" v-on:click="inputJizen()" >入力する</button>
        
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;;background-color: gray;"  v-else v-on:click="non_upload()" >入力する</button></td>
      </tr>
      <tr>
        <td><h3>事後集会プログラムCSVファイル</h3></td>
        <td><input type='file' id="jigo_file" @change="jigoChange" accept=".csv"/></td>
      </tr>
      <tr>
        <td colspan=2 style="text-align: center;">
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-if="jigo_complete" v-on:click="inputJigo()" >入力する</button>
        
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;;background-color: gray;"  v-else v-on:click="non_upload()" >入力する</button></td>
      </tr>
      <tr>
        <td><h3>体験プログラムCSVファイル</h3></td>
        <td><input type='file' id="taiken_file" @change="taikenChange" accept=".csv"/></td>
      </tr>
      <tr>
        <td colspan=2 style="text-align: center;">
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;"  v-if="taiken_complete" v-on:click="inputTaiken()" >入力する</button>
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;background-color: gray;"  v-else v-on:click="non_upload()" >入力する</button>
        </td>
      </tr>
    </table>
  </div><br/><br/>
  <div>
    入力処理後にエラーを含む処理結果が表示されます。<br/><br/>
    <textarea class="form-control enter_forcus" id="results_error" name="results_error" rows="100" style="width:100%"
     v-model="results_error"
         maxlength="5000"></textarea>
  </div>
  </template>
  <template v-else>
    ※申込開始日になったため、インポート機能はご利用いただけません。

  </template>
        <!--フッター-->
        <FooterArea v-on:call="call"/>
      </main>
    </div>
    <div id="vy_right_nav" class="p-4">
        <!--右サイドバー-->
        <ShakyoRightBar v-on:call="call"/>
    </div>
  </div>
</div>


    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
              v-bind:message_text="message"
              v-bind:message_cat="message_cat"
              v-bind:message_flag="message_flag"
              @close_message="Close_message"
              @ok_message="OK_message"/>
              
</template>

<script setup>
/* eslint-disable */ 
import ShakyoLeftbar from './ShakyoLeftBar.vue'
import ShakyoRightBar from './ShakyoRightBar.vue'
import FooterArea from '../common/FooterArea.vue'
    import MessageModal from './ShakyoMessageModal.vue'
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, login_check } from '../js/userdata_shakyo.js'
import AWS from 'aws-sdk';
//import {
//    CognitoUserPool,
//    CognitoUser,
//    AuthenticationDetails } from 'amazon-cognito-identity-js'
import { ref } from 'vue';
import { shallowRef, watch } from 'vue'
import axios from 'axios'
const url = GlobalData.$API_URL
//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()

let title = "インポート"
GlobalData.shakyo = route.params.shakyo

// 締切フラグ　1:事業単位、2:プログラム単位
let end_shubetsu = 1;

let inport_disp = ref(false)

//---------------- 社協英名から市区町村コードと受付〆切日フラグ、申込開始日を取得
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
        {shakyo:route.params.shakyo}
        ).then(response => {

            GlobalData.choson_code = response["data"].choson_code
            end_shubetsu = response["data"].end_shubetsu
            
            let moshikomi_date = new Date(response["data"].moshikomi_date+" "+response["data"].moshikomi_start)
            let today = new Date()
        
            moshikomi_date = moshikomi_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            moshikomi_date = new Date(moshikomi_date);
            moshikomi_date.setHours(moshikomi_date.getHours());

            // 今日が申込開始日より前なら削除可能
            if (moshikomi_date > today) {
                inport_disp.value = true;
            }

     }).catch(error => {
          
     })

const prop = defineProps(['param'])
const emit = defineEmits(['call'])


// アップロード完了フラグ（このフラグが経つまで
let taiken_complete = ref(false)
let jizen_complete = ref(false)
let jigo_complete = ref(false)

// 今日の日付を取得
let set_date = new Date();
set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
set_date = new Date(set_date);
let nendo = ref(parseInt(set_date.getFullYear()))
let disp_nendo = ref(nendo.value)
login_check();

if (GlobalData.$ID_Token.headers.Authorization == '') {
    router.push("/"+GlobalData.shakyo+"/Kanri/MailLogin")
}
let taiken_filename =""
let jizen_filename =""
let jigo_filename =""

const taikenChange = (e) => {
  const fileInput = e.target;
  const file = fileInput.files[0];

  let today = new Date()

  taiken_filename = 'taiken'+GlobalData.shakyo+ today.getFullYear()+ (today.getMonth()+1)+ today.getDate()+ today.getHours()+ today.getMinutes()+ today.getSeconds()+'.csv'

  //results_error.value = "ファイルのアップロード完了まで「入力」ボタンはクリックできません。"
  upload(file, taiken_filename, GlobalData.$ID_Token,"taiken");
  
}

const jizenChange = (e) => {
  const fileInput = e.target;
  const file = fileInput.files[0];
 // results_error.value = "ファイルのアップロード完了まで「入力」ボタンはクリックできません。"
 
 let today = new Date()

 jizen_filename = 'jizen'+GlobalData.shakyo+ today.getFullYear()+ (today.getMonth()+1)+ today.getDate()+ today.getHours()+ today.getMinutes()+ today.getSeconds()+'.csv'

  upload(file, jizen_filename, GlobalData.$ID_Token,"jizen");
}
const jigoChange = (e) => {
  const fileInput = e.target;
  const file = fileInput.files[0];
 // results_error.value = "ファイルのアップロード完了まで「入力」ボタンはクリックできません。"
 
 let today = new Date()

 jigo_filename = 'jigo'+GlobalData.shakyo+ today.getFullYear()+ (today.getMonth()+1)+ today.getDate()+ today.getHours()+ today.getMinutes()+ today.getSeconds()+'.csv'

  upload(file, jigo_filename, GlobalData.$ID_Token,"jigo");
}

let error_count = 0
function upload (uploadedFile, filename, idtoken,flg) {
    // PROVEDER_KEY作成
    let PROVIDER_KEY = 'cognito-idp.ap-northeast-1.amazonaws.com/' + GlobalData.$UserPoolId;
    AWS.config.region = 'ap-northeast-1';
    // IDプールにてIDトークンの認証を行う
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: GlobalData.$IdentityPoolId,
        Logins: {
            [PROVIDER_KEY]: idtoken.headers.Authorization,
        }
    });

    //資格情報のリフレッシュ処理
    AWS.config.credentials.refresh((err) => {
      if(err) {
            if(error_count == 5){
                    alert(err);
                }else{
                    error_count++
                    setTimeout(function(){ upload(uploadedFile, filename, idtoken,flg)},"1000")
                }
          return;
      }
    });
    
    // S3オブジェクト作成
    var s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: 'ap-northeast-1'
    });

    // パラメータ作成
    const params = {
      Bucket: GlobalData.$CSV_bucket,
      Key: GlobalData.shakyo+'/'+filename,
    }
    params.Body=uploadedFile;

    return new Promise((resolve, reject) => {
      // S3へオブジェクトをアップロード
      s3.putObject(params, (err, data) => {
        if (err) {
          if(flg == "taiken"){
            taiken_complete.value = false
          }else if(flg == "jigo"){
            jigo_complete.value = false

          }else{
            jizen_complete.value = false

          }
          reject(err)
        } else {
          if(flg == "taiken"){
            taiken_complete.value = true
          }else if(flg == "jigo"){
            jigo_complete.value = true
          }else{
            jizen_complete.value = true
          }

          results_error.value = ""
          resolve(data)
        }
      })
    })
}

function non_upload(){
  alert("ファイルがアップロードされるまでお待ちください。")
}

let input_taiken_error = 0

function inputTaiken() {
  const obj = document.getElementById('taiken_file');
  const taiken_file = document.getElementById("taiken_file").files[0]
  
  if(taiken_file != undefined){

    axios.post(url + "Taiken_csvCheck_v2",
    {"nendo":disp_nendo.value,
    "choson_code":GlobalData.choson_code,
    "shakyo":GlobalData.shakyo,
    "end_shubetsu":end_shubetsu,
    "filename":taiken_filename})
      //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        obj.value = ''

        if(response.data.status == 0){
          const query = response.data.query_program
          const query2 = response.data.query_nittei
          
          const bunrui1 = response.data.bunrui1
          const bunrui2 = response.data.bunrui2
          setupCategory(bunrui1,bunrui2)
          insertTaiken(query,query2)
          
        }else if(response.data.status == 1){
          results_error.value = "プログラムのエラーにより中断されました。CSVファイルの文字コードをご確認ください。\n※文字コードは「SHIFT-JIS」に変更してください。"

        }else if(response.data.status == 2){
          results_error.value = response.data.error_text
         
        }else if(response.data.status == 3){
          results_error.value = "プログラムのエラーにより中断されました。情報を入力していない行は、プログラムNo.も入力しないでください。"

        }
    })
    .catch(error => {
      if(input_taiken_error == 6){
        results_error.value = error + GlobalData.$axios_error;
      }else{
        input_taiken_error++
        setTimeout(function(){inputTaiken()},"1000")
      }
    })
  }else{
    alert("アップロードするファイルを選択してください。")
  }
  taiken_complete.value = false
}

function setupCategory(bunrui1,bunrui2){
  
  let set_bunrui = []
  for(var c = 0;c < bunrui1.length;c++){
    if(set_bunrui.length != 0){

      let set_zumi = 0 // 追加済みかどうか 0：まだ追加していない
      for(var b1 = 0;b1 < set_bunrui.length;b1++){

        // 名称が同じかつ種別が同じものがあれば追加済みとする
        if(bunrui1[c].name == set_bunrui[b1].name && bunrui1[c].shubetsu == set_bunrui[b1].shubetsu){
          set_zumi = 1
        }
      }

      if(set_zumi == 0){
        set_bunrui[set_bunrui.length] = {"name":bunrui1[c].name,"shubetsu":bunrui1[c].shubetsu,"bunrui":1,"bunrui1_name":null}
      }

    }else{
      set_bunrui[set_bunrui.length] = {"name":bunrui1[c].name,"shubetsu":bunrui1[c].shubetsu,"bunrui":1,"bunrui1_name":null}
    }

  }
  for(var c = 0;c < bunrui2.length;c++){

    if(bunrui2[c].name != "nan"){

      let set_zumi = 0 // 追加済みかどうか 0：まだ追加していない
      for(var b2 = 0;b2 < set_bunrui.length;b2++){
        // 名称・所属する分類1・種別が同じであれば追加済みとする
        if(bunrui2[c].name == set_bunrui[b2].name
          && bunrui2[c].bunrui1_name == set_bunrui[b2].bunrui1_name
          && bunrui2[c].shubetsu == set_bunrui[b2].shubetsu){
          set_zumi = 1
        }
      }

      if(set_zumi == 0){
        set_bunrui[set_bunrui.length] = {"name":bunrui2[c].name,"shubetsu":bunrui2[c].shubetsu,"bunrui":2,"bunrui1_name":bunrui2[c].bunrui1_name}
      }

    }
  }

    

  // 入力
  let update_array = "名称,種別,分類,分類１の名称\n" // １行目
    
  for(var c3 = 0;c3 < set_bunrui.length;c3++){
        // 編集した内容を保存する
        update_array += set_bunrui[c3]['name']+","
        update_array += parseInt(set_bunrui[c3]['shubetsu'])+","
        update_array += parseInt(set_bunrui[c3]['bunrui'])+","
        update_array += set_bunrui[c3]['bunrui1_name']+"\n"
  }

  
  //results_error.value = update_array
  categoryUpload(update_array)
}


function categoryUpload(uploadedFile){

        // PROVEDER_KEY作成
        let PROVIDER_KEY = 'cognito-idp.ap-northeast-1.amazonaws.com/' + GlobalData.$UserPoolId;
        AWS.config.region = 'ap-northeast-1';
        // IDプールにてIDトークンの認証を行う
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: GlobalData.$IdentityPoolId,
            Logins: {
                [PROVIDER_KEY]: GlobalData.$ID_Token.headers.Authorization,
            }
        });

        //資格情報のリフレッシュ処理
        AWS.config.credentials.refresh((err) => {
        if(err) {
            if(error_count == 5){
              alert("分類の更新に失敗しました。"+err);
            }else{
              error_count++
              setTimeout(function(){categoryUpload(uploadedFile)},"1000")
            }
            return;
        }
        });
        // S3オブジェクト作成
        var s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        region: 'ap-northeast-1'
        });

        // パラメータ作成
        const params = {
            Bucket: GlobalData.$CSV_bucket,
            Key: GlobalData.shakyo+'/category.csv',
        }
        params.Body=uploadedFile;

        return new Promise((resolve, reject) => {
            // S3へオブジェクトをアップロード
            s3.putObject(params, (err, data) => {
                if (err) {
                  reject(err)
                  if(error_count == 5){
                    alert("分類の更新に失敗しました。"+err);
                  }else{
                    error_count++
                    setTimeout(function(){categoryUpload(uploadedFile)},"1000")
                  }
                } else {
                    resolve(data)
                 
                }
            })
        })
}

let insert_taiken_count = 0
function insertTaiken(query,query2) {
    axios.post(url + "Taiken_insert",{"query_program":query,"query_nittei":query2,"choson_code":GlobalData.choson_code})  //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data.status == 0){
          results_error.value = "データの登録が完了しました。"
          
        }else if(response.data.status == 1){
          results_error.value = "入力プログラムのエラーにより、登録が中断されました。お手数ですが、さんこう株式会社までお問い合わせください。"

        }
    })
    .catch(error => {
        if(insert_taiken_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          insert_taiken_count++
          setTimeout(function(){insertTaiken(query,query2)},"1000")
        }
    })
}

let input_jizen_count = 0
function inputJizen() {
  const obj = document.getElementById('jizen_file');
  const jizen_file = document.getElementById("jizen_file").files[0]
  
  
  if(jizen_file != undefined){
    
    axios.post(url + "Jizen_csvCheck",{"nendo":disp_nendo.value,"choson_code":GlobalData.choson_code,"shakyo":GlobalData.shakyo,"filename":jizen_filename})
      //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        obj.value = ''
        if(response.data.status == 0){
          const query = response.data.query
          insertJizen(query)
        }else if(response.data.status == 1){
          results_error.value = "プログラムのエラーにより中断されました。CSVファイルの文字コードをご確認ください。\n※文字コードは「SHIFT-JIS」に変更してください。"

        }else if(response.data.status == 2){
          results_error.value = response.data.error_text
        }
    })
    .catch(error => {
          
        if(input_jizen_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          input_jizen_count++
          setTimeout(function(){inputJizen()},"1000")
        }
    })
    jizen_complete.value = false
  }else{
    alert("アップロードするファイルを選択してください。")
  }
}

let insert_jizen_count = 0
function insertJizen(query) {
    axios.post(url + "Jizen_insert",{"query_jizen":query,"choson_code":GlobalData.choson_code})  //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data.status == 0){
          results_error.value = "データの登録が完了しました。"
          
        }else if(response.data.status == 1){
          results_error.value = "入力プログラムのエラーにより、登録が中断されました。お手数ですが、さんこう株式会社までお問い合わせください。"

        }
    })
    .catch(error => {
        if(insert_jizen_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          insert_jizen_count++
          setTimeout(function(){insertJizen(query)},"1000")
        }
    })
}

let input_jigo_count = 0
function inputJigo() {
  const obj = document.getElementById('jigo_file');
  const jigo_file = document.getElementById("jigo_file").files[0]
  
  
  if(jigo_file != undefined){
    
//    alert(nendo.value)
    axios.post(url + "Jigo_csvCheck",{"nendo":disp_nendo.value,"choson_code":GlobalData.choson_code,"shakyo":GlobalData.shakyo,"filename":jigo_filename})
      //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        obj.value = ''
        if(response.data.status == 0){
          const query = response.data.query
          insertJigo(query)
        }else if(response.data.status == 1){
          results_error.value = "プログラムのエラーにより中断されました。CSVファイルの文字コードをご確認ください。\n※文字コードは「SHIFT-JIS」に変更してください。"

        }else if(response.data.status == 2){
          results_error.value = response.data.error_text
        }
    })
    .catch(error => {
      
        if(input_jigo_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          input_jigo_count++
          setTimeout(function(){inputJigo()},"1000")
        }
    })
    jigo_complete.value = false
  }else{
    alert("アップロードするファイルを選択してください。")
  }
}

let insert_jigo_count = 0
function insertJigo(query) {
    axios.post(url + "Jigo_insert",{"query_jigo":query,"choson_code":GlobalData.choson_code})  //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data.status == 0){
          results_error.value = "データの登録が完了しました。"
          
        }else if(response.data.status == 1){
          results_error.value = "入力プログラムのエラーにより、登録が中断されました。お手数ですが、さんこう株式会社までお問い合わせください。"

        }
    })
    .catch(error => {
        if(insert_jigo_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          insert_jigo_count++
          setTimeout(function(){insertJigo(query)},"1000")
        }
    })
}

let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/1c1c0be34f8f80bbbc27f1ffe9816967"
    window.open(url,"_blank")
}

let qanda_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/Q-A-177c0be34f8f80f08c74c585be043e05"
    window.open(url,"_blank")

}

  /* メッセージを表示するモーダルウィンドウ */
  let message = ref("")//表示するメッセージ
  let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
  let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
  let message_flag = ref(false)//表示・非表示フラグ

  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント
  
  //-------------- URLが変わった時に対応する処理を起動するためのフック -----------------
  const wt = watch(route, () => {
      param = { cmd:route.params.cmd, id:route.params.id }
      call(param)
  })
  
  //-------------- URLに応じた処理のコンポーネントを呼び出す -------------------
  const call = function(proc) {
  
      switch(proc.cmd) {
          case 'open_taikensha':
              // 子コンポーネント側（ShakyoRightBar）からの命令でウィンドウを開く
              
                message_cat.value = 2;
                message_flag.value = true;
                contentMessage.value = MessageModal
              break
          default:
              break
      }
  }
</script>
<style scoped>
td {border:none;text-align:right;padding:20px}
</style>
